import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main/Main';
import { useTranslation } from 'react-i18next';

export const QuickVideos = () => {
  const { t } = useTranslation();
  return (
    <>
      <DocumentHead title={t('Quick Videos')} />
      <PageTemplate main={<Main />} />
    </>
  );
};
